import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { NGXLogger } from 'ngx-logger';
import { catchError, Observable, of, switchMap } from 'rxjs';

import { BaseUrlService } from '../../../auth/authentication/base-url.service';
import { ValidationService } from '../../utils/valibot/validation.service';
import { Translation } from '../library/translation';
import { TranslationLoader } from '../library/translation-loader';
import { TranslationSchema } from './translation.schema';

@Injectable({
  providedIn: 'root',
})
export class TranslationLoaderService implements TranslationLoader {
  private readonly http = inject(HttpClient);
  private readonly logger = inject(NGXLogger);
  private readonly validationService = inject(ValidationService);

  private readonly baseUrl$ = toObservable(inject(BaseUrlService).baseUrlSetByInput);

  getTranslations(language: string): Observable<Translation> {
    // in initialization phase the baseUrlService.baseUrlSetByInput is not set yet.
    // If a base URL is set, the translations need to be reloaded. (The first load fails in this case.)
    return this.baseUrl$.pipe(
      switchMap(() =>
        this.http.get(`/assets/i18n/${language}.json`).pipe(
          this.validationService.pipeResponse(TranslationSchema),
          catchError((err) => {
            this.logger.warn('#CDFTF0001 Cannot load translations for ' + language, err);
            return of({});
          }),
        ),
      ),
    );
  }
}
